export const nlpStates = {
  isReviewed: 'reviewed',
  isOutOfScope: 'isOutOfScope',
  isEscalated: 'isEscalated',
  isInvalid: 'validity',
}
